import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
export async function trackEvent(eventName, payload = {}) {
    try {
        await addDoc(collection(db, 'analytics_events'), {
            event: eventName,
            ...payload,
            ts: new Date().toISOString(),
        });
    } catch (e) {
        console.warn('Analytics error:', e);
    }
}